import { FindCaseModal } from './FindCaseModal';
import { IValidation } from '../../../interfaces/IError';
import React from 'react';
import { Stack } from 'react-bootstrap';

export interface ICaseSearchControlProps {
    onCaseSelected: (caseGuid: string) => void;
    onClearSearchFilter: () => void;
}
export function CaseSearchControl(props: ICaseSearchControlProps) {
    const [validation, setValidation] = React.useState<IValidation>({});
    const [searchString, setSearchString] = React.useState<string>('');
    const [showCaseSearchModal, setShowCaseSearchModal] = React.useState<boolean>(false);

    const handleClearSearchFilter = () => {
        setSearchString('');
        props.onClearSearchFilter();
    };

    const handleSearchInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        setSearchString(event.target.value);
    };

    const handleShowCaseSearchModal = () => {
        const localValidation: IValidation = {};
        if (!searchString || searchString.trim() == '') {
            localValidation.caseNameOrNumberSearch = ['Enter a Case Number or Case Name'];
            setShowCaseSearchModal(false);
            setValidation(localValidation);
        } else {
            localValidation.caseNameOrNumberSearch = [''];
            setValidation(localValidation);
            setShowCaseSearchModal(true);
        }
    };

    const handleCaseSelected = (caseGuid: string) => {
        props.onCaseSelected(caseGuid);
        setSearchString('');
        setShowCaseSearchModal(false);
    };

    return (
        <>
            <div className="row mb-3">
                <label className="text-gray text-lg col-sm-2">Case</label>
                <div className="col-sm-3">
                    <input
                        className="form-control full-width full-max-width"
                        type="text"
                        name="caseNameOrNumberSearch"
                        placeholder="Search by Name or Number"
                        value={searchString}
                        onChange={handleSearchInputChange}
                    />
                    <span className="text-danger">{validation?.caseNameOrNumberSearch}</span>
                </div>
                <div className="col p-0">
                    <Stack direction="horizontal">
                        <button
                            type="submit"
                            className="btn btn-black btn-icon"
                            style={{ minHeight: '100%' }}
                            onClick={handleShowCaseSearchModal}
                        >
                            <i className="fal fa-search color-white" />
                        </button>
                        <button
                            type="button"
                            className="btn btn-gray btn-icon"
                            style={{ marginRight: '5px', minHeight: '100%' }}
                            onClick={handleClearSearchFilter}
                        >
                            <i className="fal fa-times color-white" />
                        </button>
                    </Stack>
                </div>
            </div>

            {showCaseSearchModal && (
                <FindCaseModal
                    onCancel={() => setShowCaseSearchModal(false)}
                    onSelectCase={handleCaseSelected}
                    open={showCaseSearchModal}
                    searchString={searchString}
                />
            )}
        </>
    );
}
